import { Combobox } from '@headlessui/react'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { XmarkCircleSolid } from 'iconoir-react'
import { ReactElement } from 'react'

type Props = {
  comboDropdownInputRef: React.MutableRefObject<HTMLInputElement>
  handleSearchValueChange?: (value: string) => void
  onClearSearch?: () => void
}

export function ComboBoxInputSearch({
  comboDropdownInputRef,
  handleSearchValueChange,
  onClearSearch,
}: Props): ReactElement {
  return (
    <div className="relative -order-3 border-b border-trn-200">
      <Combobox.Input
        data-testid="combo-input"
        autoComplete="off"
        className="combobox-input"
        placeholder={`Type to search`}
        ref={comboDropdownInputRef}
        onChange={(event) => handleSearchValueChange?.(event.target.value)}
        autoFocus
      />
      {comboDropdownInputRef.current?.value && (
        <div className="stuff-on-the-right absolute inset-y-0 right-2 flex items-center rounded-r-md">
          <XmarkCircleSolid
            className="chevron chevron-icon block text-trn-400"
            onClick={(evt) => {
              evt.stopPropagation()
              comboDropdownInputRef.current.value = ``
              comboDropdownInputRef.current.focus()
              onClearSearch?.()
            }}
          />
        </div>
      )}
      <span className="absolute inset-y-0 left-0 flex items-center pl-4">
        <MagnifyingGlassIcon className="h-4 w-4" />
      </span>
    </div>
  )
}
